<template>

  <modalo
    :title="null"
    type="medium"
    :padding="'0px'"
    @hideModal="hideModal()">

    <div
      v-if="!creating"  
      class="vflex">

      <div class="vflex-row-0 vflex-header p-3">
        <div class="page-title">
          <div class="title">
            <h4>{{ $t('Tasks') }}</h4>
          </div>
          <div class="btn-row">

            <div class="dropdown">
              <button
                class="btn btn-sm btn-light dropdown-toggle"
                type="button"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false">
                <i class="fas fa-cog" />
              </button>
              <div class="dropdown-menu dropdown-menu-right p-3">
                <div class="btn-group btn-block mb-1">
                  <button
                    type="button"
                    class="btn btn-sm"
                    @click="setFilter({ scope: 'my' })"
                    :class="filters.scope === 'my' ? 'btn-dark' : 'btn-outline-dark'">
                    {{ $t('Mine') }}
                    </button>
                  <button
                    type="button"
                    class="btn btn-sm"
                    @click="setFilter({ scope: 'all' })"
                    :class="filters.scope === 'all' ? 'btn-dark' : 'btn-outline-dark'">
                    {{ $t('All') }}
                    </button>
                </div>

                <div class="btn-group btn-block">
                  <button
                    type="button"
                    class="btn btn-sm"
                    @click="setFilter({ completed: false })"
                    :class="filters.completed === false ? 'btn-dark' : 'btn-outline-dark'">
                    {{ $t('Pendings') }}
                    </button>
                  <button
                    type="button"
                    class="btn btn-sm"
                    @click="setFilter({ completed: true })"
                    :class="filters.completed === true ? 'btn-dark' : 'btn-outline-dark'">
                    {{ $t('Completed') }}
                    </button>
                </div>

              </div>
            </div>

          </div>
        </div>
      </div>

      <div class="vflex-row-1">
        <Paginaty
          :total="paginate.total"
          :pages="paginate.pages"
          :page="paginate.page"
          :creating="creating"
          :loading="loading"
          @changePage="loadData">
        
          <template slot="content">
            <ul class="list-group list-group-flush">
              <task-list-item
                v-for="(task, index) in tasks"
                :key="index"
                :task="task"
                @updated="loadData(paginate.page)">
                </task-list-item>
            </ul>
          </template>

          <template slot="noresults">
            {{ $t('There are no items') }}
          </template>

        </Paginaty>
      </div>

    </div>
  </modalo>

</template>

<script>
import Paginaty from '@/components/Paginaty/Paginaty'
import TaskListItem from './TaskListItem'

export default {
  name: 'TaskList',
  components: {
    Paginaty,
    TaskListItem
  },
  data () {
    return {
      creating: true,
      loading: true,
      sort: 'date',
      filters: {
        completed: false,
        scope: 'my'
      }
    }
  },
  computed: {
    tasks () {
      return this.$store.getters.getTasks
    },
    paginate () {
      return this.$store.getters.getTasksPaginate
    }
  },
  created () {
    this.loadData(1)
  },
  methods: {
    /*
    loadData
    */
    loadData (page) {
      this.loading = true

      const params = {
        ...this.filters,
        page: page,
        sort: this.sort,
        limit: this.$default.limit
      }

      this.$store
      .dispatch('selectTasks', params)
      .then((result) => {
        if (result.docs.length === 0 && result.page > 1) this.loadData(1)
        this.loading = this.creating = false
      })
    },
    setFilter (filters) {
      this.filters = {
        ...this.filters,
        ...filters
      }
      this.loadData(1)
    },
    hideModal () {
      this.$emit('hideModal')
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Task/TaskList.vue